import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../setup'
import axios from 'axios'
import { OCCUPATIONAL_THERAPIST_NOTES_CONSTANT,OCCUPATIONAL_THERAPIST_NOTES_CONSTANT_INITIAL_VALUES, } from '../../../Notes/Occupational_therapy/OCCUPATIONAL_THERAPIST_NOTES_CONSTANT'
import FormWrapper from '../../../../reusable-components/Wrapper/Wrapper'
import {MoonLoader} from 'react-spinners'
import {
  Box,
  Typography,
} from '@mui/material'
import BackButton from '../../../../reusable-components/Buttons/BackButton'
import DynamicForm from '../../../../reusable-components/forms/DynamicForm'
import {toast} from 'react-toastify'
import {useHistory, useParams} from 'react-router-dom'
import FrequencyDateRangePicker from '../../../../reusable-components/NoteType/NoteType'
import DescriptionModal from '../../../../reusable-components/description-modal/descriptionmodal'
const selectTimeZone = (state: RootState) => state.timeZone.timeZone
const OccupationalTherapyAssesmentForm = () => {
  const [formData, setFormData] = useState(OCCUPATIONAL_THERAPIST_NOTES_CONSTANT_INITIAL_VALUES)
  const [uiElements, setUiElements] = useState([])
  const timeZone = useSelector(selectTimeZone)
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const [clientId, setClientId] = useState(null)
  const {id}: {id: string} = useParams()
useEffect(() => {
    const fetchNoteData = async () => {
      try {
        setLoading(true); 
        const responseForNote = await axios.get(`/otProgressNotes/getById/${id}`, {
          params: {
            isDeleted: true, 
          }
        });
        
        const {result: noteData} = responseForNote?.data;
        
        const clientOption = {
          label: noteData.clientFullName, 
          value: noteData.clientId
        };
        
        const updatedclients = [clientOption];
        
        setClientId(noteData.clientId);
        
        const updatedNoteData = {
          ...noteData,
          date: noteData.date,
          OT: noteData.OT,
          clientId: noteData.clientId,
          noteType: noteData.noteType,
          location: noteData.location,
          addrInfo: noteData.location,
          selfCare: noteData?.occupationGoals?.selfCare,
          communityAccess: noteData?.occupationGoals?.communityAccess,
          playAndLeisure: noteData?.occupationGoals?.playAndLeisure,
          domestic: noteData?.occupationGoals?.domestic,
          education: noteData?.occupationGoals?.education,
          restAndSleep: noteData?.occupationGoals?.restAndSleep,
          socialParticipation: noteData?.occupationGoals?.socialParticipation,
          otherDetails: noteData?.occupationGoals?.otherDetails,
          performanceAreas: noteData.performanceAreas,
          performanceAreaDetails: noteData.performanceAreaDetails,
          progressFeedback: noteData.progressFeedback,
          otActivities: noteData.presentation?.otActivities,
          observations: noteData.presentation?.observations,
          otSuggestions: noteData.presentation?.otSuggestions,
        };
        
        // Updated mapping to disable all fields
        const updatedFormData = OCCUPATIONAL_THERAPIST_NOTES_CONSTANT.map((item) => {
          if (item.name === 'clientId') {
            return {
              ...item, 
              options: updatedclients, 
              disabled: true,  // Disable clientId field
              value: noteData.clientId  // Set the value for clientId
            }
          }
          // Disable all other fields and set their values
          return {
            ...item, 
            disabled: true,  // This disables all other fields
            value: updatedNoteData[item.name] || ''  // Set the value from updatedNoteData
          }
        })
        
        setFormData(updatedNoteData)
        setUiElements(updatedFormData)
      } catch (error) {
        console.error('Error fetching note data:', error)
      } finally {
        setLoading(false)
      }
    }
    
    fetchNoteData();
  }, [])


  const buttons = [
    {
      label: 'Cancel',
      variant: 'outlined',
      type: 'button',
    },
  ]


  return (
    <>
      {loading ? (
        <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
          <MoonLoader color='#9db2fc' size={60} loading={loading} />
        </div>
      ) : (
        <FormWrapper
          title='Deleted OT Assessment'
          content={
            <>
                <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        marginBottom: '1rem',
                        marginRight: '0.5rem',
                        gap: '0.5rem',
                      }}
                    >
                      <BackButton />
              </Box>
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 'bold',
                marginBottom: '0.5rem',
                marginLeft: '1rem',
              }}
                  color='primary'
                >
                  Note Type
                </Typography>
            <FrequencyDateRangePicker
              isEntry = {false}
              isTemplate = {false}
              isFullForm = {false}
              isEdit = {true}
              formData={formData}
              setFormData={setFormData}
            />
              <DynamicForm
                fields={uiElements}
                data={formData}
                onSubmit={() => {}}
                buttons={buttons}
                setFormValues={setFormData}
              />
            </>
          }
          buttons={buttons}
        />
      )}
    </>
  )
}

export default OccupationalTherapyAssesmentForm
